// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Transitions.dev - Design System Micro-interactions
 * Crafted micro-transitions & physics-based UI motion
 */
:root {
  /* Tabs sliding tokens */
  --tabs-dur: 260ms;
  --tabs-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --tabs-text-muted: #64748b;
  --tabs-text-active: #0f172a;
  --tabs-bar-bg: #f1f5f9;
  --tabs-pill-bg: #ffffff;
  /* Card tilt tokens */
  --tilt-perspective: 1000px;
  --tilt-return: 800ms;
  --tilt-return-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --tilt-follow: 250ms;
  --tilt-follow-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --tilt-glare-opacity: 0.28;
  --tilt-glare-fade: 260ms;
  --tilt-glare-ease: cubic-bezier(0.22, 1, 0.36, 1);
  /* Error shake tokens */
  --shake-distance: 6px;
  --shake-overshoot: 4px;
  --shake-dur: 350ms;
  /* Micro-animation curves */
  --ease-spring: cubic-bezier(0.34, 1.4, 0.64, 1);
  --ease-smooth: cubic-bezier(0.22, 1, 0.36, 1);
}

/* =========================================
   1. TABS SLIDING (Segmented Controls)
   ========================================= */
.t-tabs {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background: var(--tabs-bar-bg);
  border: 1px solid #e2e8f0;
  -webkit-user-select: none;
          user-select: none;
}

.t-tabs-full {
  display: flex;
  width: 100%;
}

.t-tabs-full .t-tab {
  flex: 1 1;
}

.t-tab {
  position: relative;
  appearance: none;
  border: 0;
  background: transparent;
  min-height: 38px;
  padding: 6px 14px;
  color: var(--tabs-text-muted);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  border-radius: 9px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: color var(--tabs-dur) var(--tabs-ease);
}

.t-tab:not(.is-active):hover {
  color: var(--tabs-text-active);
  background: rgba(255, 255, 255, 0.45);
}

.t-tab.is-active {
  color: var(--tabs-text-active);
}

.t-tab-icon {
  font-size: 1.05rem;
  display: inline-flex;
  align-items: center;
}

.t-tabs-pill {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 0;
  width: 0;
  background: var(--tabs-pill-bg);
  border-radius: 9px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  transform: translateX(0);
  transition: transform var(--tabs-dur) var(--tabs-ease), width var(--tabs-dur) var(--tabs-ease), opacity 180ms ease;
  will-change: transform, width;
  z-index: 0;
  pointer-events: none;
}

/* =========================================
   2. CARD HOVER TILT (3D Reactive Surface)
   ========================================= */
.t-tilt {
  touch-action: none;
  position: relative;
}

.t-tilt-card {
  position: relative;
  border-radius: inherit;
  transform: perspective(var(--tilt-perspective)) rotateX(var(--tilt-rx, 0deg)) rotateY(var(--tilt-ry, 0deg));
  transform-style: preserve-3d;
  transition: transform var(--tilt-return) var(--tilt-return-ease), box-shadow 300ms ease;
  will-change: transform;
}

.t-tilt-card.is-tilting {
  transition: transform var(--tilt-follow) var(--tilt-follow-ease), box-shadow 150ms ease;
}

.t-tilt-glare {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0;
  border-radius: inherit;
  mix-blend-mode: screen;
  background: radial-gradient(circle 100px at var(--tilt-gx, 50%) var(--tilt-gy, 50%), rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0.06) 52%, rgba(255, 255, 255, 0) 84%), radial-gradient(circle 220px at var(--tilt-gx, 50%) var(--tilt-gy, 50%), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.04) 58%, rgba(255, 255, 255, 0) 78%);
  transition: opacity var(--tilt-glare-fade) var(--tilt-glare-ease);
}

.t-tilt.is-hover .t-tilt-glare {
  opacity: var(--tilt-glare-opacity);
}

/* =========================================
   3. ERROR STATE SHAKE (Validation Feedback)
   ========================================= */
@keyframes t-error-shake {
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(calc(-1 * var(--shake-distance)));
  }
  40% {
    transform: translateX(var(--shake-overshoot));
  }
  60% {
    transform: translateX(calc(-1 * var(--shake-overshoot)));
  }
  80% {
    transform: translateX(2px);
  }
  100% {
    transform: translateX(0);
  }
}
.t-shake-error {
  animation: t-error-shake var(--shake-dur) var(--ease-smooth);
}

/* =========================================
   4. NUMBER POP-IN & SPRING INTERACTIONS
   ========================================= */
@keyframes t-pop-in {
  0% {
    opacity: 0;
    transform: translateY(6px) scale(0.92);
    filter: blur(2px);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}
.t-number-pop {
  animation: t-pop-in 240ms var(--ease-spring);
  display: inline-block;
}

/* Button Micro-Press Spring */
.t-btn-press {
  transition: transform 150ms var(--ease-spring), box-shadow 150ms ease;
}

.t-btn-press:hover {
  transform: translateY(-2px);
}

.t-btn-press:active {
  transform: translateY(1px) scale(0.97);
}

/* Panel Accordion Reveal */
.t-panel-reveal {
  overflow: hidden;
  transition: max-height 320ms var(--ease-smooth), opacity 260ms ease, transform 300ms var(--ease-spring);
}

/* Reduced motion accessibility */
@media (prefers-reduced-motion: reduce) {
  .t-tilt-card,
  .t-tabs-pill,
  .t-tab,
  .t-shake-error,
  .t-number-pop,
  .t-btn-press {
    transform: none !important;
    animation: none !important;
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/transitions.css"],"names":[],"mappings":"AAAA;;;EAAA;AAKA;EACE,wBAAA;EACA,iBAAA;EACA,2CAAA;EACA,0BAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;EAEA,qBAAA;EACA,0BAAA;EACA,oBAAA;EACA,kDAAA;EACA,oBAAA;EACA,kDAAA;EACA,0BAAA;EACA,wBAAA;EACA,iDAAA;EAEA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,2BAAA;EACA,+CAAA;EACA,6CAAA;AAHF;;AAMA;;8CAAA;AAGA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,yBAAA;UAAA,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,WAAA;AAHF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kDAAA;AAHF;;AAMA;EACE,8BAAA;EACA,qCAAA;AAHF;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,+BAAA;EACA,kBAAA;EACA,8EAAA;EACA,wBAAA;EACA,kHACE;EAGF,6BAAA;EACA,UAAA;EACA,oBAAA;AANF;;AASA;;8CAAA;AAGA;EACE,kBAAA;EACA,kBAAA;AANF;;AASA;EACE,kBAAA;EACA,sBAAA;EACA,2GACE;EAGF,4BAAA;EACA,uFAAA;EACA,sBAAA;AATF;;AAYA;EACE,uFAAA;AATF;;AAYA;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,UAAA;EACA,sBAAA;EACA,sBAAA;EACA,yUACE;EAIF,iEAAA;AAbF;;AAgBA;EACE,kCAAA;AAbF;;AAgBA;;8CAAA;AAGA;EACE;IAAK,wBAAA;EAZL;EAaA;IAAM,uDAAA;EAVN;EAWA;IAAM,6CAAA;EARN;EASA;IAAM,wDAAA;EANN;EAOA;IAAM,0BAAA;EAJN;EAKA;IAAO,wBAAA;EAFP;AACF;AAIA;EACE,4DAAA;AAFF;;AAKA;;8CAAA;AAGA;EACE;IACE,UAAA;IACA,sCAAA;IACA,iBAAA;EAFF;EAIA;IACE,UAAA;IACA,iCAAA;IACA,eAAA;EAFF;AACF;AAKA;EACE,4CAAA;EACA,qBAAA;AAHF;;AAMA,8BAAA;AACA;EACE,qEAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,sCAAA;AAHF;;AAMA,2BAAA;AACA;EACE,gBAAA;EACA,uGAAA;AAHF;;AAMA,iCAAA;AACA;EACE;;;;;;IAME,0BAAA;IACA,0BAAA;IACA,2BAAA;EAHF;AACF","sourcesContent":["/**\n * Transitions.dev - Design System Micro-interactions\n * Crafted micro-transitions & physics-based UI motion\n */\n\n:root {\n  /* Tabs sliding tokens */\n  --tabs-dur: 260ms;\n  --tabs-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --tabs-text-muted: #64748b;\n  --tabs-text-active: #0f172a;\n  --tabs-bar-bg: #f1f5f9;\n  --tabs-pill-bg: #ffffff;\n\n  /* Card tilt tokens */\n  --tilt-perspective: 1000px;\n  --tilt-return: 800ms;\n  --tilt-return-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --tilt-follow: 250ms;\n  --tilt-follow-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --tilt-glare-opacity: 0.28;\n  --tilt-glare-fade: 260ms;\n  --tilt-glare-ease: cubic-bezier(0.22, 1, 0.36, 1);\n\n  /* Error shake tokens */\n  --shake-distance: 6px;\n  --shake-overshoot: 4px;\n  --shake-dur: 350ms;\n\n  /* Micro-animation curves */\n  --ease-spring: cubic-bezier(0.34, 1.4, 0.64, 1);\n  --ease-smooth: cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n/* =========================================\n   1. TABS SLIDING (Segmented Controls)\n   ========================================= */\n.t-tabs {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  border-radius: 12px;\n  background: var(--tabs-bar-bg);\n  border: 1px solid #e2e8f0;\n  user-select: none;\n}\n\n.t-tabs-full {\n  display: flex;\n  width: 100%;\n}\n\n.t-tabs-full .t-tab {\n  flex: 1;\n}\n\n.t-tab {\n  position: relative;\n  appearance: none;\n  border: 0;\n  background: transparent;\n  min-height: 38px;\n  padding: 6px 14px;\n  color: var(--tabs-text-muted);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 9px;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: color var(--tabs-dur) var(--tabs-ease);\n}\n\n.t-tab:not(.is-active):hover {\n  color: var(--tabs-text-active);\n  background: rgba(255, 255, 255, 0.45);\n}\n\n.t-tab.is-active {\n  color: var(--tabs-text-active);\n}\n\n.t-tab-icon {\n  font-size: 1.05rem;\n  display: inline-flex;\n  align-items: center;\n}\n\n.t-tabs-pill {\n  position: absolute;\n  top: 4px;\n  bottom: 4px;\n  left: 0;\n  width: 0;\n  background: var(--tabs-pill-bg);\n  border-radius: 9px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);\n  transform: translateX(0);\n  transition:\n    transform var(--tabs-dur) var(--tabs-ease),\n    width var(--tabs-dur) var(--tabs-ease),\n    opacity 180ms ease;\n  will-change: transform, width;\n  z-index: 0;\n  pointer-events: none;\n}\n\n/* =========================================\n   2. CARD HOVER TILT (3D Reactive Surface)\n   ========================================= */\n.t-tilt {\n  touch-action: none;\n  position: relative;\n}\n\n.t-tilt-card {\n  position: relative;\n  border-radius: inherit;\n  transform:\n    perspective(var(--tilt-perspective))\n    rotateX(var(--tilt-rx, 0deg))\n    rotateY(var(--tilt-ry, 0deg));\n  transform-style: preserve-3d;\n  transition: transform var(--tilt-return) var(--tilt-return-ease), box-shadow 300ms ease;\n  will-change: transform;\n}\n\n.t-tilt-card.is-tilting {\n  transition: transform var(--tilt-follow) var(--tilt-follow-ease), box-shadow 150ms ease;\n}\n\n.t-tilt-glare {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0;\n  border-radius: inherit;\n  mix-blend-mode: screen;\n  background:\n    radial-gradient(circle 100px at var(--tilt-gx, 50%) var(--tilt-gy, 50%),\n      rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0.06) 52%, rgba(255, 255, 255, 0) 84%),\n    radial-gradient(circle 220px at var(--tilt-gx, 50%) var(--tilt-gy, 50%),\n      rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.04) 58%, rgba(255, 255, 255, 0) 78%);\n  transition: opacity var(--tilt-glare-fade) var(--tilt-glare-ease);\n}\n\n.t-tilt.is-hover .t-tilt-glare {\n  opacity: var(--tilt-glare-opacity);\n}\n\n/* =========================================\n   3. ERROR STATE SHAKE (Validation Feedback)\n   ========================================= */\n@keyframes t-error-shake {\n  0% { transform: translateX(0); }\n  20% { transform: translateX(calc(-1 * var(--shake-distance))); }\n  40% { transform: translateX(var(--shake-overshoot)); }\n  60% { transform: translateX(calc(-1 * var(--shake-overshoot))); }\n  80% { transform: translateX(2px); }\n  100% { transform: translateX(0); }\n}\n\n.t-shake-error {\n  animation: t-error-shake var(--shake-dur) var(--ease-smooth);\n}\n\n/* =========================================\n   4. NUMBER POP-IN & SPRING INTERACTIONS\n   ========================================= */\n@keyframes t-pop-in {\n  0% {\n    opacity: 0;\n    transform: translateY(6px) scale(0.92);\n    filter: blur(2px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n    filter: blur(0);\n  }\n}\n\n.t-number-pop {\n  animation: t-pop-in 240ms var(--ease-spring);\n  display: inline-block;\n}\n\n/* Button Micro-Press Spring */\n.t-btn-press {\n  transition: transform 150ms var(--ease-spring), box-shadow 150ms ease;\n}\n\n.t-btn-press:hover {\n  transform: translateY(-2px);\n}\n\n.t-btn-press:active {\n  transform: translateY(1px) scale(0.97);\n}\n\n/* Panel Accordion Reveal */\n.t-panel-reveal {\n  overflow: hidden;\n  transition: max-height 320ms var(--ease-smooth), opacity 260ms ease, transform 300ms var(--ease-spring);\n}\n\n/* Reduced motion accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .t-tilt-card,\n  .t-tabs-pill,\n  .t-tab,\n  .t-shake-error,\n  .t-number-pop,\n  .t-btn-press {\n    transform: none !important;\n    animation: none !important;\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
